module.exports = __webpack_public_path__ + "static/media/max-k-24.cf2aec02.png";